export function parsePdf(rawPdf) {
  let pdf = new Uint8Array(rawPdf.length);
  for (let i = 0; i < rawPdf.length; i++) {
    pdf[i] = rawPdf.charCodeAt(i);
  }
  return pdf;
}